import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  ProjectCustomFieldCreate,
  ProjectCustomFieldUpdate,
  projectCustomFieldsApi,
} from "@/services/projectCustomFieldsApi";

const queryKey = (projectId: string) => ["projects", projectId, "custom-fields"] as const;

export function useProjectCustomFields(projectId: string | undefined) {
  return useQuery({
    queryKey: queryKey(projectId ?? ""),
    queryFn: () => projectCustomFieldsApi.list(projectId!),
    enabled: !!projectId,
  });
}

export function useCreateProjectCustomField(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: ProjectCustomFieldCreate) =>
      projectCustomFieldsApi.create(projectId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKey(projectId) }),
  });
}

export function useUpdateProjectCustomField(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ fieldId, data }: { fieldId: string; data: ProjectCustomFieldUpdate }) =>
      projectCustomFieldsApi.update(projectId, fieldId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKey(projectId) }),
  });
}

export function useDeleteProjectCustomField(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fieldId: string) => projectCustomFieldsApi.delete(projectId, fieldId),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKey(projectId) }),
  });
}
